
import { useEffect, useState} from 'react';
import useItemSelection from './useItemSelection';
import { useFetchData } from './apiHooks';
import useSSE from "./useSSE";
import { SSE_CHANNELS, SSE_TASKS } from "constants";

export const useEmailExecution = (emailId, handleChangeEditorAndVersion) => {
    const knowledgeSelection = useItemSelection([])
    const [optionsToConsider, setOptionsToConsider] = useState({customer: false, knowledge: true, notes: false}); 

    const toggleOptionToConsider = (key) => {
        setOptionsToConsider((prev) => ({
            ...prev,
            [key]: !prev[key], 
        }));
    };

    const { triggerUpdate: recalculate, isUpdating, updateSuccess, updateError  } = 
        useFetchData(null, `/email/${emailId}/recalculate`, false);

    const handleExecute = async (item, payload) => {
        payload["knowledge_selection"] = knowledgeSelection.selectedItems;
        payload["options_to_consider"] = optionsToConsider;
        let newEmail = await recalculate(null, payload);

        if(payload.action === 'proof_read'){
            return newEmail
        }
        else if(newEmail?.email_html && newEmail?.subject){
            handleChangeEditorAndVersion(newEmail.email_html, newEmail.subject, newEmail.email_to);
        }
    };

    return { knowledgeSelection, handleExecute, recalculate, isUpdating, updateSuccess, updateError, optionsToConsider, toggleOptionToConsider };
};

export const useEmailAnalytics = (emailId) => {
    const { data: emailAnalytics, isLoading, error, refetch, saveKey } = useFetchData(`/email/${emailId}/analytics`, null, false);
    
    const { triggerUpdate: reAnalyze, isUpdating: reAnalyzing, updateSuccess, updateError  } = 
        useFetchData(null, `/email/${emailId}/recalculate`, false);
    const {data:Table, isLoading:isLoadingTable, success:successTable, error:errorTable, refetch:refetchTable, saveError:saveErrorTable, 
        isUpdating:isUpdatingTable, updateError: updateErrorTable, triggerUpdate: triggerUpdateTable, updateSuccess:updateSuccessTable
    } = useFetchData(`/email/${emailId}/analytics/trigger`, `/email/${emailId}/analytics/trigger`, false);
    const { sseSuccess, setSseSuccess } = useSSE(SSE_CHANNELS.EMAIL_UPDATE, SSE_TASKS.EXTRACT_PRODUCT_TABLE, true);

    useEffect(() => {
        if (sseSuccess) {
            refetch();
            setSseSuccess(false);
        }
    }, [sseSuccess, refetch, setSseSuccess]);

    useEffect(() => {
        if (emailId && !emailAnalytics) {
            refetch();
        }
    }, [emailId]);

    const updateAnalyticsKey = (key, value) => {
        const updatedAnalysisJson = { ...emailAnalytics.analysis_json, [key]: value };
        saveKey('analysis_json', updatedAnalysisJson)
    }

    return {
        analysis: emailAnalytics?.analysis_json, 
        emailAnalytics, isLoading, error, refetch, updateAnalyticsKey,
        reAnalyze, reAnalyzing, updateSuccess, updateError,
        Table, isLoadingTable, successTable, errorTable, refetchTable, saveErrorTable, isUpdatingTable, updateErrorTable, triggerUpdateTable, updateSuccessTable
    };
};